import React from 'react';
import { Trans, WithTranslation, withTranslation } from 'react-i18next';
import Layout from '@rezdy/components/Layout/DarkCentered';
import { Article, Aside, Body } from '@rezdy/components/Layout/Article/Styled';
import SecondaryAction from '../../components/Layout/SecondaryAction';
import TextStyle from '@rezdy/components/TextStyle';
import { Title } from '../../components/SignUpV2/Styled';
import { ContactSupport } from '../../components/ContactSupport';
import ResendCode from '../../components/ResendCode';
import Grid from '@rezdy/components/Grid';
import queryString from '../../services/queryString';
import routing from '../../services/routing';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import { DEFAULT_SIGNUP_VERSION } from '../../services/auth';
import { BookingSoftwareMarketingCard } from '../../components/BookingSoftwareMarketingCard';

const SUPPORTED_VERSIONS = [DEFAULT_SIGNUP_VERSION, '3'];

export class EmailComplete extends React.Component<WithTranslation & RouteComponentProps<{ version: string }>> {
    render(): React.ReactNode {
        const params = queryString.parse(routing.location.search);
        const version = SUPPORTED_VERSIONS.includes(this.props.match.params.version)
            ? this.props.match.params.version
            : DEFAULT_SIGNUP_VERSION;
        const username = decodeURIComponent((params.username as string) || '');
        const { i18n } = this.props;

        return (
            <Layout secondaryAction={<SecondaryAction />}>
                <Article style={{ alignItems: 'start' }}>
                    <Body>
                        <Grid.Container rowGap="24px" style={{ maxWidth: 400 }}>
                            <Title>{i18n.t('emailComplete.heading')}</Title>
                            <Trans i18nKey="verifyEmail.body">
                                <TextStyle as="p">
                                    <Trans i18nKey="emailComplete.body1">
                                        Almost there! We sent an email to <b>{{ username }}</b> to verify your account.
                                    </Trans>
                                </TextStyle>
                                <TextStyle as="p">
                                    {i18n.t('emailComplete.body2')}
                                    <br />
                                    <ResendCode username={username} version={version} />
                                </TextStyle>

                                <ContactSupport />
                            </Trans>
                        </Grid.Container>
                    </Body>
                    <Aside>
                        <BookingSoftwareMarketingCard />
                    </Aside>
                </Article>
            </Layout>
        );
    }
}

export default withTranslation()(withRouter(EmailComplete));
